
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communityPath]/[topicPath]",
      function () {
        return require("private-next-pages/community/[communityPath]/[topicPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communityPath]/[topicPath]"])
      });
    }
  